export const EXPERIMENT_GROUPS = ['control', 'variant', 'variant_a', 'variant_b', 'variant_c', 'variation', 'variation_b'];